import { render, staticRenderFns } from "./StarterHome.vue?vue&type=template&id=2702f72e&scoped=true"
import script from "./StarterHome.vue?vue&type=script&lang=js"
export * from "./StarterHome.vue?vue&type=script&lang=js"
import style0 from "./StarterHome.vue?vue&type=style&index=0&id=2702f72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2702f72e",
  null
  
)

export default component.exports